module.exports = __webpack_public_path__ + "img/saudia-1.5c41811c.png";